module.exports = new __parcel__URL__("flow-builder-light.e240704f.svg").toString();